<template>
  <ConfigErrorBoundary>
    <FileConverter
      :config="converterConfig"
      @batch-created="handleBatchCreated"
      @job-completed="handleJobCompleted"
      @batch-cleared="handleBatchCleared"
      @error="handleError"
      @credits-updated="handleCreditsUpdated"
    />
  </ConfigErrorBoundary>
</template>

<script setup lang="ts">
import FileConverter from './FileConverter.vue';
import ConfigErrorBoundary from './ConfigErrorBoundary.vue';
import { parseAndValidateConverterConfig } from '../utils/ConfigValidator';

const converterConfig = parseAndValidateConverterConfig('rar-to-zip-converter', 'RAR to ZIP');

function handleBatchCreated(batchId: string) {
  console.log('[RAR to ZIP Converter] Batch created:', batchId);
}

function handleJobCompleted(jobId: string) {
  console.log('[RAR to ZIP Converter] Job completed:', jobId);
}

function handleBatchCleared() {
  console.log('[RAR to ZIP Converter] Batch cleared');
}

function handleError(error: Error) {
  console.error('[RAR to ZIP Converter] Error:', error);
}

function handleCreditsUpdated(credits: number) {
  console.log('[RAR to ZIP Converter] Credits updated:', credits);
}
</script>
